module.exports = __webpack_public_path__ + "assets/img/mosaic-columns-4.759ac018.jpg";